import { render, staticRenderFns } from "./ArchivesStatisticst.vue?vue&type=template&id=8d3050dc&scoped=true&"
import script from "./ArchivesStatisticst.vue?vue&type=script&lang=js&"
export * from "./ArchivesStatisticst.vue?vue&type=script&lang=js&"
import style0 from "./ArchivesStatisticst.vue?vue&type=style&index=0&id=8d3050dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3050dc",
  null
  
)

export default component.exports